import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
render(<AppRouter data-id="element-3339" data-mp="1wal5es9thxta" />, document.getElementById('root'));